import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ControlContainer, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EventFormat } from '../../models/event/event.model';

@Component({
  selector: 'app-event-type-radio-input',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TranslateModule,
    RadioButtonModule,
  ],
  templateUrl: './event-type-radio-input.component.html',
  styleUrls: ['./event-type-radio-input.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class EventTypeRadioInputComponent {
  EventFormat = EventFormat;

  @Input({required: true}) FC: FormControl<EventFormat> | undefined;

  value: EventFormat | null = null;

  options: {
    value: EventFormat,
    label: string,
    description: string,
  }[] = [
    {
      value: EventFormat.SEMESTER,
      label: 'admin.event-type-radio-input.SEMESTER.title',
      description: 'admin.event-type-radio-input.SEMESTER.description'
    },
    {
      value: EventFormat.CONFERENCE,
      label: 'admin.event-type-radio-input.CONFERENCE.title',
      description: 'admin.event-type-radio-input.CONFERENCE.description'
    },
    {
      value: EventFormat.CAMP,
      label: 'admin.event-type-radio-input.CAMP.title',
      description: 'admin.event-type-radio-input.CAMP.description'
    },
    {
      value: EventFormat.FESTIVAL,
      label: 'admin.event-type-radio-input.FESTIVAL.title',
      description: 'admin.event-type-radio-input.FESTIVAL.description'
    },
    {
      value: EventFormat.OFFER,
      label: 'admin.event-type-radio-input.OFFER.title',
      description: 'admin.event-type-radio-input.OFFER.description'
    },
    {
      value: EventFormat.EVENT,
      label: 'admin.event-type-radio-input.EVENT.title',
      description: 'admin.event-type-radio-input.EVENT.description'
    }
  ];

}
